import { SettingsProvider } from './../settings/settings';
import { Observable } from 'rxjs/Observable';
import { Coin } from './../../models/Coin';
import { Portfolio, Holding } from './../../models/Portfolio';
import { CoinsProvider } from './../coins/coins';
import { AuthProvider } from './../auth/auth';
import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { combineLatest } from 'rxjs/observable/combineLatest';

@Injectable()
export class PortfolioProvider {

  portfolio: Portfolio;

  constructor(
    private auth: AuthProvider,
    private CP: CoinsProvider,
    private db: AngularFireDatabase,
    private settings: SettingsProvider
  ) {
    this.getPortfolio()
      .subscribe((portfolio: Portfolio) => {
        this.portfolio = portfolio;
      })
  }

  public getPortfolio(): Observable<Portfolio> {

    let allCoins = this.CP.getAllCoins();

    return combineLatest(this.getHoldings(), allCoins)
      .map(portObj => {
        return new Portfolio(portObj[0], portObj[1], this.CP.priceMap);
      })
  }

  private getHoldings(): Observable<Holding[]>{

    return this.settings.getUserSettings().map(settings => {
      if(settings && settings.holdings) return settings.holdings
      else return []
    })
  }

  private setHoldings(holdings: Holding[]): Observable<void> {
    let set = {'holdings': holdings}
    return this.settings.setUserSettings(set);
  }

  public setOrder(holdings: Holding[]){
    this.setHoldings(holdings).subscribe();
  }

  public isAuthenticated(){
    return this.auth.authenticated;
  }

  public add(coin: Coin): boolean {
    if(this.isAuthenticated && this.portfolio){
      this.portfolio.addCoin(coin);
      this.setHoldings(this.portfolio.holdings).first().subscribe();
      return true;
    }
    return false;
  }

  public remove(coin: Coin): boolean {
    if(this.isAuthenticated && this.portfolio){
      this.portfolio.removeCoin(coin);
      this.setHoldings(this.portfolio.holdings).subscribe();
      return true;
    }
    return false;
  }

  public setValueForCoin(coin: Coin, units: number){
    if(this.isAuthenticated && this.portfolio){
      this.portfolio.setHoldingsForCoin(coin, units);
      this.setHoldings(this.portfolio.holdings).subscribe();
    }

  }

  public coinInPortfolio(coin: Coin): Observable<boolean> {
    return this.getPortfolio()
      .map(portfolio => {
        if(portfolio) return portfolio.hasCoin(coin);
        else return false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/portfolio/portfolio.ts